import KeyboardEventBase = JQuery.KeyboardEventBase;

export let KeyboardHelper = {
  normalize(event: KeyboardEventBase, prop: keyof KeyboardEventBase): any {
    const isMac = (<any>navigator.platform).toUpperCase().indexOf('MAC') >= 0;
    switch (prop) {
      case 'metaKey':
        return isMac ? event.metaKey : event.ctrlKey
      case 'ctrlKey':
        return isMac ? event.metaKey : event.ctrlKey
      default:
        return event[prop]
    }
  },
  hasAllModifiers(event: KeyboardEventBase): boolean {
    const isLinux = (<any>navigator.platform).indexOf('Linux x86_64') >= 0;
    return (event.metaKey || isLinux) && event.ctrlKey && event.altKey && event.shiftKey
  },
  /**
   * Do not submit form if "Enter" is pressed
   * but allow normal "Enter" functionality when pressed on textarea or submit button
   */
  preventFormSubmitOnEnter(event: KeyboardEvent): void {
    const target: HTMLElement = event.target as HTMLElement
    if (!(target.tagName === 'TEXTAREA' || target.tagName === "INPUT" && (<HTMLInputElement>target).type === 'submit')) {
      event.preventDefault()
    }
  }
}
